<template>
  <div class="switch">
    <div
      v-for="item in companys"
      :key="item.id"
      class="card"
      @click="checkedCompany(item)"
    >
      <div class="left">
        <el-avatar shape="square" icon="el-icon-s-flag" class="flag-icon" />
        <span class="company-name">{{ item.name }} </span>
      </div>
      <i class="el-icon-arrow-right icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'switch-company',
  props: {
    companys: {
      type: Array,
      default: () => [],
      require: true
    }
  },
  data() {
    return {
      bodyStyle: {
        padding: '16px',
        height: '345px',
        'overflow-y': 'auto'
      }
    }
  },
  methods: {
    checkedCompany(company) {
      this.$emit('selected-company', company)
    }
  }
}
</script>

<style scoped lang="scss">
.switch {
  width: 90%;
  margin: 20px auto;
  max-height: 500px;
  overflow-y: auto;
}
.card {
  margin-bottom: 20px;
  background: #f2f2f6;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  .left {
    display: flex;
    .flag-icon {
      flex-shrink: 0;
    }
    .company-name {
      margin-left: 12px;
      line-height: 40px;
      text-align: left;
    }
  }
  .icon {
    flex-shrink: 0;
    margin: 12px 4px 0 12px;
  }
}
</style>
